import { render } from "./tasks-right.vue?vue&type=template&id=3ba71fec"
import script from "./tasks-right.vue?vue&type=script&lang=js"
export * from "./tasks-right.vue?vue&type=script&lang=js"

import "./tasks-right.vue?vue&type=style&index=0&id=3ba71fec&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__